export default {
  getDepartment(departmentID, target) {
    const obj = {
      actionType: appConstants.ActionTypes.GET_DEPARTMENT,
      postData: { target },
    };

    obj.postData[Utils.getEndpointParam('DEPARTMENT_ID_PARAM')] = departmentID;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  getDepartmentSchedule(departmentID, startDate, endDate) {
    const obj = {
      actionType: appConstants.ActionTypes.GET_DEPARTMENT_SCHEDULE,
      postData: {},
    };

    obj.postData[Utils.getEndpointParam('DEPARTMENT_ID_PARAM')] = departmentID;
    obj.postData[Utils.getEndpointParam('START_PARAM')] = startDate;
    obj.postData[Utils.getEndpointParam('END_PARAM')] = endDate;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  }
};
